<div class="wrapper">
  @if (isSavingBlocking) {
    <app-spinner class="spinner"></app-spinner>
  } @else {
    @let activeItemId = activeItemId$ | async;
    @if (!isReadonly) {
      <div class="toolbar">
        <div class="left">
          <button mat-raised-button translate="CALLS.AGENDA_EDITOR.ADD_ITEM" (click)="addNode(activeItemId)"></button>
          <button mat-raised-button translate="CALLS.AGENDA_EDITOR.ADD_SUBITEM" (click)="addSubitem(activeItemId!)" [disabled]="activeItemId === null"></button>
          <button mat-raised-button translate="CALLS.AGENDA_EDITOR.REMOVE_ITEM" (click)="removeNode(activeItemId!)" [disabled]="activeItemId === null"></button>
          <button
            mat-raised-button
            translate="CALLS.AGENDA_EDITOR.MOVE_UP"
            (click)="moveUp(activeItemId!)"
            [disabled]="activeItemId === null || !canMoveUp(activeItemId)"
          ></button>
          <button
            mat-raised-button
            translate="CALLS.AGENDA_EDITOR.MOVE_DOWN"
            (click)="moveDown(activeItemId!)"
            [disabled]="activeItemId === null || !canMoveDown(activeItemId)"
          ></button>
          <button
            mat-raised-button
            translate="CALLS.AGENDA_EDITOR.INDENT"
            (click)="indent(activeItemId!)"
            [disabled]="activeItemId === null || !canIndent(activeItemId)"
          ></button>
          <button
            mat-raised-button
            translate="CALLS.AGENDA_EDITOR.OUTDENT"
            (click)="outdent(activeItemId!)"
            [disabled]="activeItemId === null || !canOutdent(activeItemId)"
          ></button>
        </div>
        <div class="right">
          <button mat-icon-button (click)="reset()" [matTooltip]="'COMMON.RESET' | translate">
            <mat-icon>history</mat-icon>
          </button>
          @if (isSavingNonBlocking) {
            <mat-spinner diameter="20" style="margin-left: 4px"></mat-spinner>
          } @else {
            <mat-icon style="color: green">checkmark</mat-icon>
          }
        </div>
      </div>
    }
    <div class="agenda-editor-container">
      <div class="header">
        <div class="left" translate="CALLS.AGENDA_EDITOR.ITEM"></div>
        <div class="presenters" translate="CALLS.AGENDA_EDITOR.PRESENTERS"></div>
        @if (!isReadonly) {
          <div class="category" translate="CALLS.AGENDA_EDITOR.CATEGORY"></div>
          <div class="sub-categories" translate="CALLS.AGENDA_EDITOR.SUB_CATEGORY"></div>
        }
      </div>
      @for (node of agenda; track node.id) {
        <app-agenda-editor-item
          [activeItemId]="activeItemId"
          [node]="node"
          (setAsActive)="setActiveItem($event)"
          (updateNode)="updateNode($event)"
          [isReadonly]="isReadonly"
        ></app-agenda-editor-item>
      }
    </div>
  }
</div>
